import { render, staticRenderFns } from "./ProductSalesReportDetail.vue?vue&type=template&id=2b8d57ac&scoped=true&"
import script from "./ProductSalesReportDetail.vue?vue&type=script&lang=js&"
export * from "./ProductSalesReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductSalesReportDetail.vue?vue&type=style&index=0&id=2b8d57ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8d57ac",
  null
  
)

export default component.exports